module.exports = __webpack_public_path__ + "img/github.d23f5fe3.svg";